<template>
  <div class="not-found-container">
    <div class="not-found-card">
      <div class="not-found-icon">
        <i class="bi bi-compass"></i>
      </div>
      <h1 class="not-found-title">Halaman Tidak Ditemukan</h1>
      <p class="not-found-desc">
        Halaman atau menu yang Anda tuju sedang tidak tersedia atau alamat URL telah dipindahkan.
      </p>
      <div class="not-found-actions">
        <router-link to="/admin" class="ui-btn ui-btn--primary">
          <i class="bi bi-speedometer2 me-1"></i> Ke Dasbor Panel
        </router-link>
        <button type="button" @click="$router.back()" class="ui-btn ui-btn--secondary">
          <i class="bi bi-arrow-left me-1"></i> Kembali
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage',
};
</script>

<style scoped>
.not-found-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 65vh;
  padding: var(--space-6);
}

.not-found-card {
  max-width: 480px;
  width: 100%;
  text-align: center;
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-2xl);
  padding: var(--space-8);
  box-shadow: var(--shadow-md);
}

.not-found-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  background: var(--accent-subtle);
  color: var(--accent);
  font-size: 2.2rem;
  border-radius: var(--radius-full);
  margin-bottom: var(--space-5);
}

.not-found-title {
  font-family: var(--font-display);
  font-size: var(--text-2xl);
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: var(--space-3);
}

.not-found-desc {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: var(--space-6);
}

.not-found-actions {
  display: flex;
  gap: var(--space-3);
  justify-content: center;
  flex-wrap: wrap;
}
</style>
